<template>
  <div class="our aboutUs">
     <p class="our_common_title">核心价值</p>
     <img src="/static/images/m/core.jpg" alt="" class="banner">
     <div class="aboutUs_detail">
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">1</span><span>帝景价值</span></p>
         <div class="aboutUs_item_text">
           <div class='core_item'>
             1、为私人豪宅、五星级酒店及高级会所项目提供一站式健康卫浴系统解决方案;
           </div>
           <div class='core_item'>
             2、12 年高端卫浴服务，专注、专业、全心全力;
           </div>
           <div class='core_item'>
             3、品牌授权一级代理，一线品牌，合理价格;
           </div>
           <div class='core_item'>
             4、专业流程跟踪服务，安装售后，全程无忧;
           </div>
           <div class='core_item'>
             5、帝景•构建幸福健康生活!Dking wellness
           </div>
         </div>
       </div>
     </div>
     <div class="aboutUs_detail">
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">2</span><span>服务流程</span></p>
         <div class="aboutUs_item_text">
           <img src="/static/images/m/core2.png" alt="" class="core2">
         </div>
       </div>
     </div>
     <div class="aboutUs_detail">
       <div class="aboutUs_item">
         <p class="item_tittle"><span class="num">3</span><span>售后保障</span></p>
         <div class="aboutUs_item_text">
            <p class="service">BISAZZA：<router-link to='/m/our/customer_s/1'>点击打开质保说明>></router-link></p>

            <p class="service">卫浴：<router-link to='/m/our/customer_s/2'>点击打开质保说明>></router-link></p>

            <p class="service">户外SPA：<router-link to='/m/our/customer_s/3'>点击打开质保说明>></router-link></p>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){

  }
}
</script>

<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}
.aboutUs_detail{
  padding: 0.6rem 0.2rem 0;
}
.aboutUs_item{
  margin-bottom: 0.5rem;
}
.aboutUs_item:last-child{
  margin-bottom: 0;
}
.item_tittle{
  height: 0.7rem;
  line-height: 0.7rem;
  padding-right: 0.26rem;
  padding-left: 0.1rem;
  background-color: #f8f7f7;
  display: inline-block;
  border-radius: 0.04rem;
  font-size: 0.24rem;
  color: #000000;
  margin-bottom: 0.4rem;
}
.item_tittle .num{
 width: 0.5rem;
 height: 0.5rem;
 color: #fff;
 font-weight: bold;
 text-align: center;
 line-height: 0.5rem;
 display: inline-block;
 background-color: #3478f7;
 border-radius: 0.04rem;
 margin-right: 0.24rem;
}
.aboutUs_item_text{
  font-size: 0.24rem;
  color: #000;
  line-height: 200%;
}
.core_item{
  padding: 0.26rem 0;
  border-bottom: 1px dashed #d4d4d4;
}
.core_item:first-child{
  padding-top: 0;
}
.core2{
  width: 5.49rem;
}
.aboutUs_item_text .service{
  line-height: 300%;
}
.aboutUs_item_text .service a{
  color: #3478f7;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/core.vue